<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Impresión de facturas por fecha y tienda</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-6">
              <label>Fecha</label>
              <input v-model="current.fecha" class="form-control" type="date" />
            </div>
            <div class="col-6">
              <TiendaSelectComponent :current="current" />
            </div>
          </div>
          <div v-if="current.fecha && current.tienda" class="modal-footer">
            <button
              class="btn btn-success col-12"
              ref="cerrarModal"
              type="button"
              @click="GenerarReporte(current)"
            >
              Generar Reporte
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      current: {
        tienda: "",
        fecha: "",
      },
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
    };
  },
  mounted() {
    let params = new URLSearchParams(location.search);
    var tienda = params.get("tienda");
    tienda = decodeURIComponent(tienda);
    this.current.tienda = tienda;
  },
  methods: {
    GenerarReporte(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/recepcion/listado_facturas/listado_facturas.jrxml&fecha=${current.fecha}&tienda=${current.tienda}`
      );
    },
    refreshPrecios(current) {
      let self = this;
      ProductosService.getById(current.sku).then((response) => {
        self.current = response.data;
      });
      self.showModalAddPrecios();
    },

    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "cat-productos-editar",
        params: { sku: current.sku },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filter_activo,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      ProductosService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    showModalAddPrecios() {
      let self = this;
      $("#modalAddPrecios").modal();
    },
  },
};
</script>